import { render, staticRenderFns } from "./LangDropdown.vue?vue&type=template&id=4be989f7&scoped=true&"
import script from "./LangDropdown.vue?vue&type=script&lang=js&"
export * from "./LangDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LangDropdown.vue?vue&type=style&index=0&id=4be989f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be989f7",
  null
  
)

export default component.exports